import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import BinaryRain from './components/BinaryRain';
import Home from './pages/Home';
import About, { Education, Experience } from './pages/About';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import { PreferencesProvider, usePreferences } from './context/PreferencesContext';
import './styles/global.css';
import './App.css';

const sections = [['home', Home], ['education', Education], ['interests', About], ['experience', Experience], ['portfolio', Portfolio], ['contact', Contact]];

const SinglePagePortfolio = () => {
  const { language, theme } = usePreferences();
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => entry.target.classList.toggle('is-visible', entry.isIntersecting)), { threshold: 0.15 });
    const elements = document.querySelectorAll('.reveal-section');
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);
  return <div className="app-shell"><BinaryRain density={1} theme={theme} /><Navbar /><main className="single-page-content">{sections.map(([id, Component]) => <section id={id} key={id} className="portfolio-section reveal-section"><Component language={language} /></section>)}</main></div>;
};

const App = () => <PreferencesProvider><SinglePagePortfolio /></PreferencesProvider>;
export default App;